import React, { useRef, useState } from "react";

export const TableWithCopy = ({ children }) => {
  const tableRef = useRef(null);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!tableRef.current) return;
    const rows = Array.from(tableRef.current.rows);
    const text = rows
      .map((row) =>
        Array.from(row.cells)
          .map((cell) => cell.innerText.trim())
          .join("\t"),
      )
      .join("\n");
    navigator.clipboard.writeText(text);
    setCopied(true);
  };

  const handleMouseEnter = () => {
    if (copied) setCopied(false);
  };

  return (
    <div className="d-flex flex-column w-100 my-2">
      <div className="d-flex justify-content-end mb-2">
        <button
          className="btn btn-outline-primary btn-sm"
          onClick={handleCopy}
          onMouseEnter={handleMouseEnter}
          type="button"
        >
          {copied ? "Copied!" : "Copy Table"}
        </button>
      </div>
      <div style={{ overflowX: "auto", width: "100%" }}>
        <table ref={tableRef}>{children}</table>
      </div>
    </div>
  );
};

export default TableWithCopy;
